/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonQuestionIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <path d="M0.5,14.5 L0.5,17 C0.5,17.824 0.675,18.5 1.5,18.5 L1.5,23.5 L4.5,23.5 L4.5,18.5 C5.324,18.5 5.499,17.823 5.5,17 L5.5,14.5 L0.5,14.5 Z" />
      <circle cx="3" cy="11" r="1.5" />
      <polygon points="8.5 10.5 11.5 10.5 11.5 14 15 10.5 23.5 10.5 23.5 0.5 8.5 0.5" />
      <path d="M16.518,7.741 C16.245,7.741 16.024,7.962 16.024,8.235 C16.024,8.507 16.245,8.729 16.518,8.729 C16.79,8.729 17.012,8.507 17.012,8.235 C17.012,7.962 16.79,7.741 16.518,7.741 Z" />
      <path d="M15.035,3.982 C15.035,3.164 15.699,2.5 16.517,2.5 C17.335,2.5 18,3.164 18,3.982 C18,4.8 17.336,5.463 16.518,5.463 L16.518,6.5" />
    </g>
  </svg>
);

export default PersonQuestionIcon;
